import NoPartnerView from './NoPartnerView';

export default NoPartnerView;
